<script setup="">
import { computed } from "vue";

import SimpleInput from "@/Components/Form/SimpleInput.vue";
import SimpleLabel from "@/Components/Form/SimpleLabel.vue";

import { usePage } from "@inertiajs/vue3";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  update: {
    type: Function,
    required: true
  }
});

const page = usePage();
const team = computed(() => page.props.team);
const isFreePlan = computed(() => !team.value.is_paid_plan);

const utmMedium = computed({
  get: () => props.campaign.settings.utm_medium,
  set: (value) => props.update("settings.utm_medium", value)
});

const utmSource = computed({
  get: () => props.campaign.settings.utm_source,
  set: (value) => props.update("settings.utm_source", value)
});
</script>

<template>
  <div class="space-y-4">
    <div>
      <SimpleLabel classes="text-600 text-sm">MEDIUM</SimpleLabel>
      <div class="mt-4">
        <SimpleInput v-model="utmMedium" :disabled="isFreePlan" input-class="text-sm" placeholder="UTM MEDIUM을 입력해주세요." max-length="60" />
      </div>
    </div>

    <div>
      <SimpleLabel classes="text-600 text-sm">SOURCE</SimpleLabel>
      <div class="mt-4">
        <SimpleInput v-model="utmSource" :disabled="isFreePlan" input-class="text-sm" placeholder="UTM SOURCE를 입력해주세요." max-length="60" />
      </div>
    </div>
  </div>
</template>
